import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { NetworkListDescriptionCell } from './network-list-description.cell';
import { NetworkListDescriptionHeader } from './network-list-description.header';

export const NetworkListDescriptionColumn: IdentifiedColumnDef<
  GatewayNetworkModel,
  GatewayNetworkModel['description']
> = {
  enableSorting: false,
  header: NetworkListDescriptionHeader,
  cell: NetworkListDescriptionCell,
};
